module.exports = __webpack_public_path__ + "static/media/Lock.29e1013d.svg";